// Aug-2026 (User-Wunsch): Kunden-Schnellkorrektur — fehlende Adressfelder
// direkt aus der Adress-Warnung ergänzen, ohne Seitenwechsel.
import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { addressIssues } from "../lib/addressCheck";

export const CustomerAddressQuickFix = ({ customer, onSaved, onClose }) => {
    const isBiz = customer.type === "business" && (customer.company_name || "").trim();
    const [form, setForm] = useState({
        first_name: customer.first_name || "",
        last_name: customer.last_name || "",
        street: customer.street || "",
        zip: customer.zip || "",
        city: customer.city || "",
    });
    const [busy, setBusy] = useState(false);
    const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
    const stillMissing = addressIssues({ ...customer, ...form });
    const save = async () => {
        setBusy(true);
        try {
            const patch = {
                street: form.street.trim() || null,
                zip: form.zip.trim() || null,
                city: form.city.trim() || null,
                ...(isBiz ? {} : {
                    first_name: form.first_name.trim() || null,
                    last_name: form.last_name.trim() || null,
                }),
            };
            const { data } = await api.patch(`/customers/${customer.id}`, patch);
            toast.success("Kundenanschrift aktualisiert");
            onSaved(data && data.id ? data : { ...customer, ...patch });
        } catch (e) {
            toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen");
        }
        setBusy(false);
    };
    const missWrap = (label) => stillMissing.includes(label) ? "border-amber-400 bg-amber-50" : "";
    return (
        <div className="mt-2 border border-amber-300 bg-white rounded-sm p-2.5" data-testid="customer-addr-quickfix" onClick={(e) => e.stopPropagation()}>
            <div className="text-[11px] font-bold uppercase tracking-wider text-gray-700 mb-1.5">Anschrift ergänzen</div>
            <div className="grid grid-cols-2 gap-1.5">
                {!isBiz && (
                    <>
                        <Input value={form.first_name} onChange={upd("first_name")} placeholder="Vorname" className={`h-8 text-sm rounded-sm ${missWrap("Vorname")}`} data-testid="quickfix-first-name" />
                        <Input value={form.last_name} onChange={upd("last_name")} placeholder="Nachname" className={`h-8 text-sm rounded-sm ${missWrap("Nachname")}`} data-testid="quickfix-last-name" />
                    </>
                )}
                <Input value={form.street} onChange={upd("street")} placeholder="Straße + Hausnummer" className={`col-span-2 h-8 text-sm rounded-sm ${missWrap("Straße") || missWrap("Hausnummer")}`} data-testid="quickfix-street" />
                <Input value={form.zip} onChange={upd("zip")} placeholder="PLZ" className={`h-8 text-sm rounded-sm font-mono-num ${missWrap("PLZ")}`} data-testid="quickfix-zip" />
                <Input value={form.city} onChange={upd("city")} placeholder="Ort" className={`h-8 text-sm rounded-sm ${missWrap("Ort")}`} data-testid="quickfix-city" />
            </div>
            <div className="mt-2 flex items-center justify-between gap-2">
                <span className="text-[10px] text-gray-500">
                    {stillMissing.length ? `Fehlt noch: ${stillMissing.join(", ")}` : "✓ Anschrift vollständig"}
                </span>
                <div className="flex gap-1.5">
                    <Button type="button" size="sm" variant="outline" onClick={onClose} className="h-7 text-[11px] rounded-sm" data-testid="quickfix-cancel">Abbrechen</Button>
                    <Button type="button" size="sm" onClick={save} disabled={busy} className="h-7 text-[11px] rounded-sm bg-[#111827] text-white hover:bg-black" data-testid="quickfix-save">
                        {busy ? "Speichert…" : "Speichern"}
                    </Button>
                </div>
            </div>
        </div>
    );
};
